import qs from 'query-string';
import { GetAllQuestionParams } from '@/config/types';
import showError from '@/handler/error';
import { apiTmx } from '../api-config';

const token = sessionStorage.getItem('chave') as string;

export const getAllQuestion = async (params: GetAllQuestionParams) => {
  const query = qs.stringify(params);
  try {
    const response = await apiTmx.get(`/api/evidence/new/getFast?${query}`, {
      headers: { Authorization: token },
    });

    if (response.data.hasErrors) {
      throw new Error();
    }

    return response.data;
  } catch (err) {
    return showError(err);
  }
};
